import { Component } from '@angular/core'
import { UpdateService } from '../../../services/update.service'

/**
 * Non-blocking prompt shown when a new app version has downloaded and is ready
 * to activate. Tapping "Reload" activates the new service-worker version and
 * reloads onto it. Styled blue to read as "info / new version" rather than the
 * red "alert" banners (push / install), so they're distinguishable if they
 * ever appear together.
 */
@Component({
  selector: 'app-update-banner',
  standalone: true,
  template: `
    @if (updates.updateReady()) {
    <div class="update-banner">
      <div class="flex items-center gap-3">
        <div class="w-10 h-10 bg-white rounded-xl flex items-center justify-center flex-shrink-0 shadow-lg">
          <i class="fas fa-arrows-rotate text-blue-700 text-lg"></i>
        </div>
        <div class="flex-1 min-w-0">
          <div class="text-white font-bold text-sm">Update available</div>
          <div class="text-blue-100 text-xs mt-0.5">A new version of RCMA CAD is ready. Reload to update.</div>
        </div>
        <button (click)="reload()" [disabled]="working" class="bg-white text-blue-700 font-black px-4 py-2 rounded-lg text-sm hover:bg-blue-50 disabled:opacity-60 flex-shrink-0">
          @if (working) {
            <i class="fas fa-circle-notch fa-spin mr-1"></i>
          } @else {
            <i class="fas fa-arrows-rotate mr-1"></i>
          }
          Reload
        </button>
      </div>
    </div>
    }
  `
})
export class UpdateBannerComponent {
  working = false

  constructor(public updates: UpdateService) {}

  async reload(): Promise<void> {
    this.working = true
    await this.updates.applyUpdate()
  }
}
